<template>
  <div class="external-link">
    <h2 v-markdown="attributes.value.h2"></h2>
    <ul class="link" v-for="({href, text}, i) in attributes.value.links" :key="i">
      <li>
        <a :href="href" target="_blank">{{text}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['attributes']
}
</script>

<style lang="scss">
.external-link {
  max-width: 550px !important;
  margin: 0 auto;
  padding: 30px 50px;
  box-sizing: border-box;
  border: 1px dotted #C0CAC9;

  h2 {
    padding-bottom: 10px;
    font-size: 20px;
    line-height: 1.3;
  }

  ul {
    list-style-type: disc;
    padding-left: 20px;

    a {
      vertical-align: text-top;
      display: inline-block;
      margin-bottom: 5px;
      font-size: 16px;
    }
  }

}
</style>
